export { nl } from '@payloadcms/translations/languages/nl'
